import { Navigate } from 'react-router-dom';

import { useRandomizeNbaScoutingTabs } from './useRandomizeNbaScoutingTabs';

const ScoutingCenterPage = () => {
  const randomizedTabs = useRandomizeNbaScoutingTabs();
  return <Navigate to={randomizedTabs[0].to} />;
};
export default ScoutingCenterPage;
